import WRAP from 'WRAP-JS';
class CoastLine {
  static NAME = 'CoastLine';
  dh;
  layerConfig;
  layer;
  isDark;

  constructor(isDark) {
    this.isDark = isDark;
    this.layer = new WRAP.Geo.Layer(CoastLine.NAME);
    this.layer.setVisible(false);
    this.layer.disableInteraction(true);
  }

  initialize() {
    this.initData();
    this.initLayer()
  }

  initData() {
    this.dh = new WRAP.Data({
      "data": {
        "Type": "GeoJSON",
        "_url": "%wrap_url%/MAP_VMAP_CoastLine/%z%/%y%/%x%.json",
        "url": "pri/data/CoastLine/%z%/%y%/%x%.json",
        "cache": true,
        "Grid" : {
          "MinZoom" : 3,
          "MaxZoom" : 10,
          "BoundingBox" : {
            "West":-180.0,
            "South":-90.0,
            "East":180.0,
            "North":90.0
          }
        }
      }
    });
  }

  initLayer() {
    this.layerConfig = {
      "Name": "CoastLine",
      "Renderer": "GeoJSON",
      "Attributes": {
        "features": [
          {
            "style": {
              "default": {
                "type": "line",
                "_line_color": "#774c33",
                "line_color": "#000",
                "line_width": 1
              },
              "dark": {
                "type": "line",
                "line_color": "#FFA500",
                "line_width": 1
              }
            }
          }
        ]
      }
    };
    this.layer.configure(this.dh, this.layerConfig);
    this.applyMapColor(null, this.isDark);
  }

  async drawLayer(visible) {
    if (!this.dh) {
      this.initialize();
    }
    this.setVisible(visible);
  }

  getLayer() {
    return this.layer;
  }

  setVisible(visible) {
    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? "dark" : "default";
    this.layer.setStyle(style);
  }
}

export default CoastLine;